import { CircularProgress } from '@material-ui/core'
import React from 'react'
import NotYourCard from 'src/assets/svg/NotYourCard'

// @src imports
import { EmptyState, Modal } from 'src/chrome'
import { GiftFragment } from 'src/graphql/generated/graphql'
import {
  useActions,
  useFlagsWithUseQueries,
  useSelector,
  useState,
} from 'src/hooks'
import { useGift } from 'src/react_query'

import GiftDetails from './GiftDetails'
import ModalFooter from './ModalFooter/ModalFooter'

const GIFT_CARDS_IDS = new Set(['63', '2144', '2145', '2146'])

type Props = {
  slug: string
  onClose: () => void
  addGift: (gift: GiftFragment) => void
  isChangingGift: boolean
}

type ContentKey = 'description' | 'contents' | 'packaging' | 'shipping'

const contentKeys: { [slideIndex: number]: ContentKey } = {
  0: 'description',
  1: 'contents',
  2: 'packaging',
  3: 'shipping',
}

const GiftModal: React.FC<Props> = props => {
  const [slideIndex, setSlideIndex] = useState(0)
  const { addGift, slug, onClose, isChangingGift } = props
  const actions = useActions()
  const isMobile = useSelector(state => state.window.isMobile)
  const { hasMembershipRewards } = useFlagsWithUseQueries()

  const { data: gift, error } = useGift({ slug })

  return error ? (
    <EmptyState
      action={() => {
        onClose()
        actions.openGiftStore()
      }}
      actionTitle={'Find a new gift'}
      message={"Ooops, it looks like this gift doesn't exist"}
      artWorkWidth={'70%'}
      artWorkMaxWidth={600}
    >
      <NotYourCard />
    </EmptyState>
  ) : gift ? (
    <Modal
      title={gift.name}
      imageUrl={gift.defaultVariation?.defaultImageUrl ?? ''}
      bodyChildren={
        <GiftDetails
          content={gift.defaultVariation?.[contentKeys[slideIndex]] ?? ''}
        />
      }
      footerChildren={
        <ModalFooter
          gift={gift}
          index={slideIndex}
          handleChange={setSlideIndex}
          addGift={addGift}
          isMobile={isMobile}
          isChangingGift={isChangingGift}
        />
      }
      onClose={onClose}
      animationStyle={'fade'}
      mobileBodyStyles={{ maxHeight: '20vh' }}
      mobileContainerStyles={{
        height: 'calc(100vh - 58px)',
        top: 0,
        left: 0,
        transform: 'initial',
        overflow: 'auto',
      }}
      extraPillInfo={
        hasMembershipRewards && GIFT_CARDS_IDS.has(gift.realId)
          ? [{ title: 'Membership Rewards not available', color: '#ffe3af' }]
          : undefined
      }
    />
  ) : (
    <Modal
      title=""
      onClose={() => onClose()}
      bodyChildren={<CircularProgress />}
    />
  )
}

export default GiftModal
